document.addEventListener('DOMContentLoaded', function () {
  const gridViewBtn = document.querySelector('.itg_grid_view');
  const listViewBtn = document.querySelector('.itg_list_view');
  const gridListMain = document.querySelector('.itg_grid_list_main');
  const dropdown = document.querySelector('.select_option_dropdown');
  const letters = document.querySelectorAll('.letter_sorting_title');
  const searchInput = document.getElementById('itg_input_search');
  const gridItems = gridListMain ? Array.from(gridListMain.querySelectorAll('.itg_grid_items_col')) : [];

  if (!gridListMain) return;

  // View toggle 
  gridListMain.classList.add('grid_view_active');
  if (gridViewBtn) gridViewBtn.classList.add('view_active');

  gridViewBtn?.addEventListener('click', () => {
    gridListMain.classList.add('grid_view_active');
    gridListMain.classList.remove('list_view_active');
    gridViewBtn.classList.add('view_active');
    listViewBtn?.classList.remove('view_active');
  });

  listViewBtn?.addEventListener('click', () => {
    gridListMain.classList.add('list_view_active');
    gridListMain.classList.remove('grid_view_active');
    listViewBtn.classList.add('view_active');
    gridViewBtn?.classList.remove('view_active');
  });

  // Dropdown sorting 
  dropdown?.addEventListener('change', function () {
    const value = this.value.toLowerCase();
    const sortedItems = gridItems.slice().sort((a, b) => {
      const titleA = a.querySelector('h5')?.textContent.trim().toLowerCase() || '';
      const titleB = b.querySelector('h5')?.textContent.trim().toLowerCase() || '';
      if (value === 'title-ascending') return titleA.localeCompare(titleB);
      if (value === 'title-descending') return titleB.localeCompare(titleA);
      return 0;
    });
    gridListMain.innerHTML = '';
    sortedItems.forEach(item => gridListMain.appendChild(item));
  });

  // Letter filter 
  function filterByLetter(letter) {
    gridItems.forEach(item => {
      const title = item.querySelector('h5')?.textContent.trim().toLowerCase() || '';
      const firstLetter = title.charAt(0);
      item.style.display = (letter === 'all' || firstLetter === letter) ? '' : 'none';
    });
  }
  const defaultLetterEl = document.querySelector('.letter_sorting_title[data-id="all"]');
  defaultLetterEl?.classList.add('active_letter');
  filterByLetter('all');
  letters.forEach(letterEl => {
    letterEl.addEventListener('click', () => {
      letters.forEach(l => l.classList.remove('active_letter'));
      letterEl.classList.add('active_letter');
      const selectedLetter = letterEl.getAttribute('data-id')?.toLowerCase() || 'all';
      filterByLetter(selectedLetter);
    });
  });

  // search 
  searchInput?.addEventListener('input', function () {
    const query = this.value.toLowerCase().trim();
    gridItems.forEach(item => {
      const title = item.querySelector('h5')?.textContent.toLowerCase() || '';
      const content = item.textContent.toLowerCase();
      item.style.display = (title.includes(query) || content.includes(query)) ? '' : 'none';
    });
  });

});
